/**
 * 是否移动端设备
 * @returns {boolean}
 */
export default function isMobile() {
  const userAgent =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent,
    );
  const touch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  const width = window.innerWidth <= 768;
  return userAgent || (touch && width);
}
